// extracted by mini-css-extract-plugin
export default {"container":"style_container__uVaCl","header":"style_header__n7G4H","content":"style_content__06Rqz","dateWrapper":"style_dateWrapper__x6r26"};